import * as angular from 'angular';
import {IController} from "angular";

export class SubTaskActionsTableCtrl implements IController {
  actions: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('subTaskActionsTable', {
    bindings: {
      actions: '<'
    },
    template: require('./sub-task-actions-table.html').default,
    controller: SubTaskActionsTableCtrl
  });


